import { getVideoEditionsEditListRefetchInterval } from '@app/modules/video-editions';
import { useWebAppListEditsVideoEditorEdits } from '@mi-front/api-v2';

/**
 * Lists video editor edits for a fragment; refetches on an interval only while a render job is pending.
 */
export function useFragmentVideoEditionsEditsQuery(fragmentId: string) {
  return useWebAppListEditsVideoEditorEdits(
    { fragmentId },
    {
      query: {
        refetchInterval: (query) => getVideoEditionsEditListRefetchInterval(query.state.data),
      },
    },
  );
}
